<template>
  <div class="lg:mt-10 md:mt-10 mt-8">
    <div class="text-center w-2/3 mx-auto">
      <h2 class="text4F0A4B fsize30 sm-fsize24 mb-2">
        Guidance from Your
        <span class="font-semibold"> Healthcare Provider</span>
      </h2>
      <p class="lg:mb-4 md:mb-4 mb-2 sm-fsize14">
        Your healthcare provider will help you understand cancer treatment
        options and their implications, so don’t hesitate to ask questions.
      </p>
    </div>
    <div class="lg:mt-12 md:mt-10 mt-6 grid grid-cols-3 gap-x-6 gap-y-8 m-3">
      <div
        v-for="(volunteer, index) in volunteerList"
        :key="index"
        class="bg-fff px-4 py-5 card_guidance_img flex-col justify-center items-center"
      >
        <img
          :src="
            `${$imageURL}/${volunteer.profile}` ||
            'https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg'
          "
          alt="india"
          class="h-20 w-20 rounded-full object-cover mx-auto"
        />
        <h2 class="fsize20 font-bold text4F0A4B text-center pt-2">
          {{ volunteer.fullName || "No Name Available" }}
        </h2>
        <p class="fsize14 text4F0A4B text-center">
          {{ volunteer.designation || "No designation Available" }}
        </p>
        <div class="text-center">
          <h2 class="uppercase clr-black fsize12 font-semibold pt-5 pb-2 mx-10">
            {{
              volunteer.designationheadline ||
              "No designationheadline Available"
            }}
          </h2>
          <p class="fsize13 clr-black mx-3 leading-5">
            {{ volunteer.aboutServicePro || "No description Available" }}
          </p>
        </div>
      </div>

      <!-- ///////////// -->
      <!-- <div
        class="bg-fff px-4 py-5 card_guidance_img flex-col justify-center items-center"
      >
        <img
          src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
          alt="india"
          class="h-20 w-20 rounded-full object-cover mx-auto"
        />
        <h2 class="fsize20 font-bold text4F0A4B text-center pt-2">
          Dr. Ashalata Menon
        </h2>
        <p class="fsize14 text4F0A4B text-center">
          Licensed Therapist and Counselor
        </p>
        <div class="text-center">
          <h2 class="uppercase clr-black fsize12 font-semibold pt-5 pb-2 mx-10">
            Providing Emotional Support: Caring Together
          </h2>
          <p class="fsize13 clr-black mx-3 leading-5">
            Emotional support is just as important as physical care. Listening
            to your loved one’s concerns and taking care of your own emotional
            well-being can make the journey easier for both of you.
          </p>
        </div>
      </div> -->

      <!-- <div
        class="bg-fff px-4 py-5 card_guidance_img flex-col justify-center items-center"
      >
        <img
          src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
          alt="india"
          class="h-20 w-20 rounded-full object-cover mx-auto"
        />
        <h2 class="fsize20 font-bold text4F0A4B text-center pt-2">
          Dr. Shubhankar Kashyap
        </h2>
        <p class="fsize14 text4F0A4B text-center">MD, Oncology Specialist</p>
        <div class="text-center">
          <h2 class="uppercase clr-black fsize12 font-semibold pt-5 pb-2 mx-10">
            Financial Assistance: Easing the Burden
          </h2>
          <p class="fsize13 clr-black mx-3 leading-5">
            Cancer treatment can be costly, but there are financial support
            options available. Be sure to explore assistance programs and speak
            to a social worker to help manage the expenses
          </p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      volunteerList: [], // Array to store volunteer data
    };
  },
  computed: {
    ...mapState("respitecare", {
      get_volunteer_by_location: "get_volunteer_by_location",
      getVolunteerByService: "getVolunteerByService",
      getVolunteerByDesignation: "getVolunteerByDesignation",
    }),
    ...mapState("respitecare", ["get_volunteer_by_admin"]),
  },
  methods: {
    async dataLoad() {
      const payload = {
        designation: null,
      };

      try {
        const result = await this.$store.dispatch(
          "respitecare/getVolunteerByDesignation",
          payload
        );

        let volunteers = result.data;
        this.volunteerList = volunteers.map((volunteer) => {
          if (volunteer.userId) {
            let userData = volunteer.userId;
            return {
              fullName: `${userData.firstname} ${userData.lastname}`,
              designation: volunteer.designation,
              designationheadline: volunteer.designationheadline,
              profile: volunteer.profile,
              aboutServicePro: volunteer.aboutServicePro,
            };
          } else {
            return {};
          }
          // Adjust this if not JSON
        });

        console.log("volunteerList", this.volunteerList);
      } catch (error) {
        console.error("Error loading volunteer data:", error);
      }
    },
  },
  mounted() {
    this.dataLoad();
    console.log("get_volunteer_by_location", this.get_volunteer_by_location);
    console.log("getVolunteerByService", this.getVolunteerByService);
    console.log("get_volunteer_by_admin", this.get_volunteer_by_admin);
    console.log("getVolunteerByDesignation", this.getVolunteerByDesignation);
  },
};
</script>
